import { Masonry } from '@mui/lab';
import { Box, Avatar, Typography, Paper, Rating } from '@mui/material';
 


const testimonials = [
  {
    text: 'RogerOps handled our cloud migration flawlessly. The transition was smooth, with zero downtime, and we saw performance improvements immediately. Truly top-tier service!',
    author: 'Anubhav Singh',
    position: 'IT Head, Havells ',
    rating: 5,
    image: '/api/placeholder/80/80',
  },
  {
    text: 'Our deployment times dropped from hours to minutes after RogerOps revamped our DevOps processes. Their team is sharp, responsive, and results-driven.',
    author: 'Rishi',
    position: 'CEO, MeetMinutes',
    rating: 5,
    image: '/api/placeholder/80/80',
  },
  {
    text: 'Their Kubernetes expertise is unmatched. RogerOps helped us scale seamlessly and optimize our workloads. Our infrastructure is now rock-solid.',
    author: 'Vishal Kumar',
    position: 'CTO, TVGenie',
    rating: 5,
    image: '/api/placeholder/80/80',
  },
  {
    text: 'RogerOps integrated security into every stage of our DevOps pipeline. Our compliance audits became stress-free, and we sleep easier at night.',
    author: 'Jennifer M.',
    position: 'CISO, HealthGrid',
    rating: 5,
    image: '/api/placeholder/80/80',
  },
  {
    text: "We went from having no real backup plan to a fully tested, automated disaster recovery solution. RogerOps made us truly resilient.",
    author: 'Pramit',
    position: 'CEO, ChallanWallah',
    rating: 5,
    image: '/api/placeholder/80/80',
  },
 
{
  text: 'With RogerOps’ AWS media workflow expertise, we streamlined our video processing pipeline, reduced rendering time by 40%, and optimized storage costs without compromising quality. They helped us design a scalable, automated media architecture that handles peak workloads effortlessly.',
  author: 'Laura White',
  position: 'Project Manager, Creative Agency',
  rating: 5,
  image: '/api/placeholder/80/80',
},

 
];

export default function TestimonialsSection() {
  return (
    <Box sx={{ backgroundColor: '#f3f4f6', py: 8, px: 2 }}>
      <Box maxWidth="lg" mx="auto">
        <Typography variant="h4" align="center" gutterBottom fontWeight="bold">
          Testimonials
        </Typography>

        <Masonry style={{width:'auto'}} columns={{ xs: 1, sm: 2, md: 3 }} spacing={3}>
          {testimonials.map((testimonial, i) => (
            <Paper
              key={i}
              elevation={3}
              sx={{
                p: 3,
                backgroundColor: '#000',
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,
              }}
            >
              <Rating value={testimonial.rating} readOnly sx={{ mb: 2 }} />
              <Typography variant="body1" sx={{ mb: 3 }}>
                {testimonial.text}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 'auto' }}>
                <Avatar
                  src={testimonial.image}
                  alt={testimonial.author}
                  sx={{ mr: 2 }}
                />
                <Box>
                  <Typography fontWeight="bold">
                    {testimonial.author}
                  </Typography>
                  <Typography variant="caption" color="gray">
                    {testimonial.position}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Masonry>
      </Box>
    </Box>
  );
}
